var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBubbleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.185 16h-.281c-.255-.076-.416-.251-.553-.473a239.751 239.751 0 0 0-1.648-2.614.286.286 0 0 0-.188-.122c-.728-.05-1.457-.07-2.182-.136-1.428-.13-2.419-.875-2.958-2.201C.122 9.832.102 9.16.067 8.504.014 7.538.009 6.57 0 5.602c-.008-.892.073-1.78.216-2.658C.45 1.502 1.726.308 3.179.19c1-.08 2.006-.112 3.009-.167.093-.005.185-.015.278-.023H9.53c.093.008.185.018.278.023.992.054 1.987.08 2.977.165A3.286 3.286 0 0 1 15.68 2.58c.15.546.182 1.126.256 1.692.035.272.044.547.064.82v2.5c-.007.046-.018.091-.022.137-.055.643-.102 1.286-.165 1.928-.145 1.49-1.38 2.786-2.861 2.962-.775.092-1.557.114-2.336.16-.12.007-.195.037-.262.144-.533.857-1.076 1.708-1.608 2.566-.14.227-.298.422-.56.51zM7.024 5.223h.001c0 .75-.006 1.5.003 2.25.005.327.244.61.569.65.27.032.552.036.823.005.364-.042.605-.33.607-.7.005-1.464.005-2.927-.001-4.39-.002-.405-.292-.697-.697-.72a5.405 5.405 0 0 0-.61 0c-.397.02-.687.304-.693.702-.011.735-.003 1.469-.003 2.203zm.975 5.934a1.064 1.064 0 0 0 1.06-1.066C9.058 9.51 8.57 9.03 7.987 9.035a1.068 1.068 0 0 0-1.051 1.06c-.001.586.477 1.063 1.063 1.062z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBubbleIcon);
export default ForwardRef;